import React from 'react';

import PostJobPage from '../../js/pages/PostJobPage';

export default function PostJob() {
  return <PostJobPage />;
}
